export const sanitizeInput = (input: string) => {
  if (typeof input !== 'string') return input
  const clean = input.replaceAll(/[&/\\#,+~%^'":*<>{}]/g, '').trim()
  return clean
}
